import type { SVGProps } from 'react';
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.237 11.118A2.5 2.5 0 0 0 7.5 10a2.5 2.5 0 0 0-.263-1.118m0 2.236a2.5 2.5 0 1 1 0-2.236m0 2.236 5.526 2.764m-5.526-5 5.526-2.764m0 0a2.5 2.5 0 1 0 4.472-2.237 2.5 2.5 0 0 0-4.472 2.237m0 7.764a2.5 2.5 0 1 0 4.473 2.237 2.5 2.5 0 0 0-4.473-2.237"
    />
  </svg>
);
export default SvgShare;
